import React from 'react';
import PropTypes from 'prop-types';
import './FormInputHolder.css';

export default function FormInputHolder(props) {
  const { children } = props;
  const childCount = React.Children.count(children);
  return (
    <div className="form-input-holder__container">
      {React.Children.map(children, child =>
        React.cloneElement(child, {
          className: `form-input-holder__input-${childCount}`
        })
      )}
    </div>
  );
}

FormInputHolder.defaultProps = {
  children: undefined
};

FormInputHolder.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element
  ])
};



// WEBPACK FOOTER //
// ./src/components/form/FormInputHolder.js